import { MYSTUFF_PROJECT_GUIDENCE, MYSTUFF_PROJECT_MEMBER } from '../actions/actionTypes';

let user = localStorage.getItem('userDetails');
const initialState = user ? { loggedIn: true,guidenceByData:[],teamMemberData:[]} : {guidenceByData:[],teamMemberData:[]};

export default function myStuff(state = initialState, action) {
    switch (action.type) {
        case MYSTUFF_PROJECT_GUIDENCE:
            return {
                ...state, 
                guidenceByData:action.guidenceByData,
                teamMemberData:action.teamMemberData
                
            };
        case MYSTUFF_PROJECT_MEMBER:
            return {
                ...state, 
                
                
            };
        default:
            return state
    }
}